module.exports = __webpack_public_path__ + "animations/loading.json";


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__mhf/animations/loading.json
// module id = /tool/node_modules/file-loader/dist/cjs.js??ref--4-0!/tool/project/client/src/site__mhf/animations/loading.json
// module chunks = site__mhf